import React, { useState } from 'react';
import {HOROSCOPE1} from './data/data1.js';
import {HOROSCOPE2} from './data/data2.js';
import Horoscope from './components/Horoscope/Horoscope.jsx';
import Hero from "./components/Hero/Hero.jsx";
import Header from "./components/Header/Header.jsx";
import Footer from "./components/Footer/Footer.jsx";

function App() {
  const [selectedWeek, setSelectedWeek] = useState('current');

  let horoscopes = HOROSCOPE2;
  let weekTitle = 'Current Week';

  if (selectedWeek === 'previous') {
    horoscopes = HOROSCOPE1;
    weekTitle = 'Previous Week';
  }

  function handleSelectWeek(week) {
    setSelectedWeek(week);
  }

  return (
      <div className="landing minimal-theme">
        <Header onSelectWeek={handleSelectWeek} selectedWeek={selectedWeek} />
        <Hero/>
        <main>
          <section id="services" className="features">
            <h3>Horoscope For {weekTitle}</h3>
            <ul>
              {horoscopes.map((service) => (
                  <Horoscope key={service.zodiac} {...service} />
              ))}
            </ul>
          </section>
        </main>
        <Footer/>
      </div>
  );
}

export default App;
